import { render, staticRenderFns } from "./CreateAforoAcces.vue?vue&type=template&id=74de857a&"
import script from "./CreateAforoAcces.vue?vue&type=script&lang=js&"
export * from "./CreateAforoAcces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports